/**
 * en-GB messages added by Phase 4 task C6 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c6EnGB = {
    'auth.error.password_reused': 'You have used this password before. Choose one you have not used recently.',
    'auth.error.support_not_allowed': 'This organisation has not allowed CloudSign support access.',
    'auth.error.support_not_active': 'There is no support session to end.',
    'auth.support.label': '{name} (CloudSign support)',
    'auth.support.email.subject': 'CloudSign support has signed in to {tenant}',
    'auth.support.email.body': '{name} from CloudSign support signed in to {tenant} until {until}. Reason given: {reason}. Everything they do is recorded in your audit log.',
};
//# sourceMappingURL=c6.js.map